export const REPLIES_KEY = 'replies'

const isRepliesPage = (key: string) => key.startsWith(REPLIES_KEY)

export default isRepliesPage
